<template>
  <bpb-form-stepper-button-next
    class="questionnaire__button"
    :required-fields="requiredFields"
    ><slot
  /></bpb-form-stepper-button-next>
</template>

<script>
export default {
  inject: ['questionnaireItemContext'],
  props: {
    requiredFields: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
